module.exports = __webpack_public_path__ + "img/1451438652.65d6bb23.jpg";